export default function Button(theme) {
	return {
		MuiButton: {
			styleOverrides: {
				root: {
					padding: "16px",
					fontSize: "16px",
					fontFamily: "'General Sans', sans-serif",
					fontWeight: "500",
					lineHeight: "22px",
					boxShadow: "none",
					"&:disabled": {
						backgroundColor:
							theme.palette.action.disabledBackground,
						color: theme.palette.action.disabled,
					},
					"&:hover": {
						boxShadow: "none",
					},
				},
				contained: {
					minWidth: "158px",
					padding: "16px 47px",
				},
				outlined: {
					minWidth: "158px",
					padding: "16px 47px",
				},
				text: {
					minWidth: "158px",
					padding: "0",
					"&:hover": {
						backgroundColor: "transparent",
					},
				},
			},
			variants: [
				{
					props: { variant: "contained", color: "primary" },
					style: {
						backgroundColor: theme.palette.primary.main,
						color: theme.palette.grey[0],
						border: "1px solid transparent",
						"&:hover": {
							backgroundColor: "transparent",
							color: theme.palette.primary.main,
							border: `1px solid ${theme.palette.primary.main}`,
						},
					},
				},
				{
					props: { variant: "outlined", color: "primary" },
					style: {
						backgroundColor: "transparent",
						color: theme.palette.primary.main,
						border: `1px solid ${theme.palette.primary.main}`,
						"&:hover": {
							backgroundColor: theme.palette.primary.main,
							color: theme.palette.grey[0],
							border: "1px solid transparent",
						},
					},
				},
				{
					props: { variant: "contained", color: "secondary" },
					style: {
						backgroundColor: theme.palette.secondary.main,
						color: theme.palette.grey[0],
						border: "1px solid transparent",
						"&:hover": {
							backgroundColor: "transparent",
							color: theme.palette.secondary.main,
							border: `1px solid ${theme.palette.secondary.main}`,
						},
					},
				},
				{
					props: { variant: "outlined", color: "secondary" },
					style: {
						backgroundColor: "transparent",
						color: theme.palette.secondary.main,
						border: `1px solid ${theme.palette.secondary.main}`,
						"&:hover": {
							backgroundColor: theme.palette.secondary.main,
							color: theme.palette.grey[0],
							border: "1px solid transparent",
						},
					},
				},
				{
					props: { variant: "contained", color: "error" },
					style: {
						backgroundColor: theme.palette.error.main,
						color: theme.palette.grey[0],
						border: "1px solid transparent",
						"&:hover": {
							backgroundColor: "transparent",
							color: theme.palette.error.main,
							border: `1px solid ${theme.palette.error.main}`,
						},
					},
				},
				{
					props: { variant: "outlined", color: "error" },
					style: {
						backgroundColor: "transparent",
						color: theme.palette.error.main,
						border: `1px solid ${theme.palette.error.main}`,
						"&:hover": {
							backgroundColor: theme.palette.error.main,
							color: theme.palette.grey[0],
							border: "1px solid transparent",
						},
					},
				},
				{
					props: { variant: "contained", color: "warning" },
					style: {
						backgroundColor: theme.palette.warning.main,
						color: theme.palette.grey[0],
						border: "1px solid transparent",
						"&:hover": {
							backgroundColor: "transparent",
							color: theme.palette.warning.main,
							border: `1px solid ${theme.palette.warning.main}`,
						},
					},
				},
				{
					props: { variant: "outlined", color: "warning" },
					style: {
						backgroundColor: "transparent",
						color: theme.palette.warning.main,
						border: `1px solid ${theme.palette.warning.main}`,
						"&:hover": {
							backgroundColor: theme.palette.warning.main,
							color: theme.palette.grey[0],
							border: "1px solid transparent",
						},
					},
				},
			],
		},
	};
}
